import * as L from 'leaflet';

const CanvasTileLayer = L.TileLayer.extend({
  createTile: function(coords, done) {
    const tile = L.DomUtil.create('canvas', 'leaflet-tile');
    const tileSize = this.getTileSize();
    tile.width = tileSize.x;
    tile.height = tileSize.y;
    const ctx = tile.getContext('2d');
    const getTilePromise = this._getTile(coords);
    if (getTilePromise)
      getTilePromise.then(
        function(textureImage) {
          if (!this._map) return;
          ctx.drawImage(textureImage, 0, 0);
          this._tileOnLoad(done, tile);
          done();
        }.bind(this),
        function(err) {
          this._tileOnError(done, tile, err);
          done();
        }.bind(this)
      );
    return tile;
  },

  _getTile: function(coords) {
    return new Promise(
      function(resolve, reject) {
        const tile = document.createElement('img');
        tile.src = this.getTileUrl(coords);
        L.DomEvent.on(tile, 'load', resolve.bind(this, tile));
        L.DomEvent.on(tile, 'error', reject.bind(this, tile));
      }.bind(this)
    );
  },
});

export default CanvasTileLayer;
